import { TableHead } from '@mui/material';
import styled from 'styled-components';

export const StyledCompanyManagementDiscipline = styled.div`
  .cmd-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;

    &-top {
      display: flex;
      justify-content: space-between;
      align-items: center;

      > span {
        display: inline-block;
        padding: 9px 10px 9px 0;
        font-size: 14px;
        font-weight: 600;
        line-height: 21px;

        position: relative;

        &::after {
          content: '*';
          position: absolute;
          top: 8px;
          right: 2px;
          color: #de3e47;
        }
      }
    }

    &-body {
    }
  }
`;

export const StyledTableHead = styled(TableHead)`
  tr {
    th {
      height: 40px;
      border-top: 0.5px solid var(--color-pale-gray);
      border-bottom: 0.5px solid var(--color-pale-gray);
      background: var(--color-off-white);
      text-align: center;
      padding: 8px;
    }
  }
`;
